import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolFromPeppolGenericDocHdrLineContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_from_peppol_generic_doc_hdr_line_container.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolFromPeppolGenericDocHdrLineService extends BaseApiTemplateService<PeppolFromPeppolGenericDocHdrLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'from-peppol-gendocs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'from-peppol-gendocs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'from-peppol-gendocs/backoffice-ep'
    this.httpClient = http;
  }
}
